exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.offer-shirt img[data-v-624a876c] {\n  width: -webkit-fill-available;\n  height: auto;\n}\n\n", ""]);

// exports
